import { render, staticRenderFns } from "./MarkdownDisplay.vue?vue&type=template&id=73cebf7a&scoped=true&"
import script from "./MarkdownDisplay.vue?vue&type=script&lang=js&"
export * from "./MarkdownDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownDisplay.vue?vue&type=style&index=0&id=73cebf7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cebf7a",
  null
  
)

export default component.exports